import { TabStyles } from '@tableau/widgets';
import { CommonStyles, cssClass, Style, textEllipsis } from '../../../common/styles/CommonStyles';

const cssPrefix = 'CardViewDetailsTooltip';
export namespace DetailsTooltipStyles {
  export const Width = 320;

  export const DetailsTooltip = cssClass(cssPrefix + 'details-tooltip', {
    fontWeight: 'normal',
    width: Width,
    paddingTop: 6,
    lineHeight: '14px',
    fontSize: '12px',
    color: TabStyles.Typography.Color.Primary,
  });

  export const DatasourceDetailsTooltip = cssClass(cssPrefix + 'datasource-details-tooltip', {
    fontWeight: 'normal',
    minWidth: 160,
    maxWidth: 365,
    flexGrow: 2,
    paddingTop: 6,
    lineHeight: '14px',
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: TabStyles.Typography.Color.Primary,
  });

  export const EntityName = cssClass(cssPrefix + 'entity-name', {
    lineHeight: '21px',
    fontWeight: 'bold',
    fontSize: '14px',
    maxHeight: '1.5em * 5',
    wordWrap: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: TabStyles.Spacing.LargeSpace,
  });

  export const MetadataSection = cssClass(cssPrefix + 'metadata-section', textEllipsis, {
    marginBottom: '14px',
    $nest: {
      '&:last-of-type': {
        marginBottom: 0,
      },
    },
  });

  export const MetadataSectionWithContentDescription = cssClass(cssPrefix + 'metadata-content-description-section', {
    marginBottom: TabStyles.Spacing.ExtraLargeSpace,
  });

  export const MetadataSmallSection = cssClass(cssPrefix + 'metadata-small-section', textEllipsis, {
    marginBottom: '10px',
  });

  export const MultiLineTitle = cssClass(cssPrefix + 'metadata-multiline-title', {
    fontWeight: 'bold',
    marginBottom: TabStyles.Spacing.MediumSpace,
  });

  export const MetadataValue = cssClass(cssPrefix + 'metadata-value', {
    marginLeft: TabStyles.Spacing.MediumSpace,
    fontWeight: 'bold',
  });

  const MetadataValueMultilineStyle: Style = {
    whiteSpace: 'normal',
    lineHeight: '1.5em',
  };

  export const MetadataValueContentDescription = cssClass(cssPrefix + 'metadata-content-description', MetadataValueMultilineStyle);

  export const metadataLineHeight = 20;

  export const IconMetadataLinkValueStyle: React.CSSProperties = {
    marginLeft: '0px',
    lineHeight: metadataLineHeight + 'px',
    marginTop: '2px',
  };

  export const IconMetadataLinkValue = cssClass(cssPrefix + 'icon-metadata-link-value', textEllipsis, {
    ...IconMetadataLinkValueStyle,
  });

  export const cartoucheIcon: Style = {
    border: '1px solid ' + TabStyles.Colors.F5,
    borderRadius: '50%',
    padding: '4.5px',
    width: '15px',
    height: '15px',
    marginRight: '6px',
    verticalAlign: 'top',
    marginBottom: '18px',
    position: 'absolute',
  };

  export const cartoucheIconWithBackground: Style = {
    ...cartoucheIcon,
    backgroundColor: CommonStyles.Colors.Grey235,
  };

  export const cartoucheIconWithoutBackground: Style = {
    ...cartoucheIcon,
    backgroundColor: TabStyles.Colors.White,
  };

  export const cartoucheIconWithBackgroundClass = cssClass(cssPrefix + 'cartoucheIconWithBackground', cartoucheIconWithBackground);

  export const cartoucheIconWithoutBackgroundClass = cssClass(cssPrefix + 'cartoucheIconWithoutBackground', cartoucheIconWithoutBackground);

  export const MetadataLinkValueStyle: React.CSSProperties = {
    marginLeft: TabStyles.Spacing.MediumSpace,
  };

  export const MetadataLinkValue = cssClass(cssPrefix + 'metadata-link-value', textEllipsis, {
    ...MetadataLinkValueStyle,
  });

  export const ContentTypeIcon = cssClass(cssPrefix + 'content-type-icon', {
    height: '100%',
    marginRight: 6,
    verticalAlign: 'top',
  });

  export const MetadataRelatedTitle = cssClass(cssPrefix + 'metadata-list-title', {
    fontWeight: 'bold',
    lineHeight: '20px',
  });
}
